import type {LayoutTemplate} from "@o2d/grid-layout";

/**
 * Layout template for the resource-planning timeline view.
 *
 * Why a dedicated layout instead of the shared `TIMELINE_LAYOUT_TEMPLATE`?
 * Resource-Planning has NO calendar aggregation row. Keeping the shared
 * layout (which declares `row-section-calendar`) produced an axis/area mismatch
 * that crashed `@o2d/timeline`. This layout omits `row-section-calendar`
 * and the corresponding `--row-section-calendar-size` CSS variable.
 *
 * Mirror of `_shared/timeline-layout.ts` minus the calendar row. Keep the
 * remaining sections in sync with the shared version.
 */
export const RESOURCE_PLANNING_LAYOUT_TEMPLATE: LayoutTemplate = {
    name: 't3',
    axisX: [
        {sectionId: 'column-section-0', count: 1, type: 'fix', sizeCssVariable: 'column-section-0-size'},
        {sectionId: 'column-section-1', count: 1, type: 'fix', sizeCssVariable: 'column-section-1-size'},
        {sectionId: 'column-section-2', count: 1, type: 'fix', sizeCssVariable: 'column-section-2-size'},
        {sectionId: 'column-section-3', count: 'auto', type: 'fluid', sizeCssVariable: 'column-section-3-size'}
    ],
    axisY: [
        {sectionId: 'row-section-0', count: 1, type: 'fix', sizeCssVariable: 'row-section-0-size'},
        {sectionId: 'row-section-1', count: 1, type: 'fix', sizeCssVariable: 'row-section-1-size'},
        {sectionId: 'row-section-2', count: 1, type: 'fix', sizeCssVariable: 'row-section-2-size'},
        {sectionId: 'row-section-3', count: 1, type: 'fix', sizeCssVariable: 'row-section-3-size'},
        {sectionId: 'row-section-4', count: 'auto', type: 'fluid', sizeCssVariable: 'row-section-4-size'}
    ]
};

/**
 * CSS variables for resource-planning section sizes.
 * Mirror of `TIMELINE_SECTION_SIZES` minus `--row-section-calendar-size`.
 */
export const RESOURCE_PLANNING_SECTION_SIZES: Record<string, string> = {
    '--column-section-0-size': '200px',
    '--column-section-1-size': '40px',
    '--column-section-2-size': '40px',
    '--column-section-3-size': '40px',
    '--row-section-0-size': '30px',
    '--row-section-1-size': '25px',
    '--row-section-2-size': '20px',
    '--row-section-3-size': '25px',
    '--row-section-4-size': '50px',
};
